import { Map, List } from "immutable";
import { APPLICANT_VERIFICATION_ACTIONS } from "constants/actions";
import { STATE_STATUS } from "constants";

const INITIAL_STATE = new Map({
    companies: new Map({}),
});

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
    case APPLICANT_VERIFICATION_ACTIONS.FETCH_ASSOCIATES_VERIFICATION_LIST:
        return state.setIn(
            ["companies", payload.companyId],
            new Map({
                status: STATE_STATUS.FETCHING,
                data: new List([]),
            })
        );
    case APPLICANT_VERIFICATION_ACTIONS.FETCHED_ASSOCIATES_VERIFICATION_LIST: {
        let data = {};
        new List(payload.data)
            .toMap()
            .groupBy((_) => _.associate && _.associate.id)
            .map((_, k) => {
                _.map((__) => {
                    data[k] = {
                        ...data[k],
                        associate: __.associate && __.associate.full_name,
                        associate_id: __.associate && __.associate.id,
                        phone_no: __.associate && __.associate.phone,
                        email_id: __.associate && __.associate.email,
                        // pan_no: __.associate && __.associate.pan,
                        // aadhar_no: __.associate && __.associate.aadhar,
                        // email: {},
                        // phone: {},
                        // pan: {},
                        // aadhar: {}
                    };
                    if (__.identity_type === "Phone Number") {
                        data[k] = {
                            ...data[k],
                            phone: {
                                verification_status: __.verification_status,
                                verification_source: __.verification_source,
                                verification_request:
                                    __.verification_request,
                                verification_response:
                                    __.verification_response,
                                requested_by: __.requested_by,
                                request_id: __.id
                            },
                        };
                    }
                    if (__.identity_type === "Aadhar") {
                        data[k] = {
                            aadhar_no: __.identity,
                            ...data[k],
                            aadhar: {
                                verification_status: __.verification_status,
                                verification_source: __.verification_source,
                                verification_request:
                                    __.verification_request,
                                verification_response:
                                    __.verification_response,
                                requested_by: __.requested_by,
                                request_id: __.id,
                                document:__.document
                            },
                        };
                    }
                    if (__.identity_type === "Pan") {
                        data[k] = {
                            ...data[k],
                            pan_no: __.identity,
                            pan: {
                                verification_status: __.verification_status,
                                verification_source: __.verification_source,
                                verification_request:
                                    __.verification_request,
                                verification_response:
                                    __.verification_response,
                                requested_by: __.requested_by,
                                request_id: __.id,
                                document:__.document
                            },

                        };
                    }
                    if (__.identity_type === "Email") {
                        data[k] = {
                            ...data[k],
                            email: {
                                verification_status: __.verification_status,
                                verification_source: __.verification_source,
                                verification_request:
                                    __.verification_request,
                                verification_response:
                                    __.verification_response,
                                requested_by: __.requested_by,
                                request_id: __.id,
                            },
                        };
                    }
                    if (__.identity_type === "Company Pan") {
                        const entity_details = payload.data.filter(_ => _.identity_type === "Company Pan") || [];
                        data[k] = {
                            company_pan: {
                                document :entity_details[0].document || null,
                                pan_no : entity_details[0].identity || "",
                                entity_name : entity_details[0].company.name || "",
                                verification_status: __.verification_status,
                                verification_source: __.verification_source,
                                verification_request:
                                    __.verification_request,
                                verification_response:
                                    __.verification_response,
                                requested_by: __.requested_by,
                                request_id: __.id,
                            },
                        };
                    }
                });
            });
        return state.setIn(
            ["companies", payload.companyId],
            new Map({
                status: STATE_STATUS.FETCHED,
                data: new Map(data).toList(),
            })
        );
    }
    case APPLICANT_VERIFICATION_ACTIONS.FAILED_FETCH_ASSOCIATES_VERIFICATION_LIST:
        return state.setIn(
            ["companies", payload.companyId],
            new Map({
                status: STATE_STATUS.FETCH_FAILED,
                data: new List([]),
            })
        );
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};
